import { roundProposalPrice } from '../src/config/blissLuxuryProposalCopy.js'

/** Existing preliminary-proposal convention: rush fabrication to $50, then
 * add delivery and round the Reserve baseline to $100 before applying tiers. */
export function customFabricationTotal(subtotal: number, timeline?: string): number {
  return timeline === 'asap' ? Math.round(subtotal * 1.2 / 50) * 50 : subtotal
}
export function customReserveBaseline(fabrication: number, delivery: number): number {
  return roundProposalPrice(fabrication + delivery)
}
